import React from 'react'
import { Link } from 'react-router'

const BlogSmallCard = ({title, content, date, urlHeading, homeImage, creator}) => {

  return (
  <>
  
  <div className="xb-blog xb-hover-zoom pos-rel ul_li">
                    <div className="xb-item--img">
                        <img src={homeImage || "https://omsoftwares.in/assets/img/seo/ogImage.png"} alt={title}/>
                    </div>
                    <div className="xb-item--inner ul_li">
                        <div className="xb-item--author">
                            <div className="xb-item--avatar">
                                {/* <img src="assets/img/blog/blog-icon_03.jpg" alt=""/> */}
                            </div>
                            <h3 className="xb-item--name"><span>By</span>: {creator === 'creator' || !creator ? 'Admin' : creator}</h3>
                            <h5 className="xb-item--date">{date}</h5>
                        </div>
                        <div className="xb-item--holder">
                            <h2 className="xb-item--title">{title}</h2>
                            <p className="xb-item--content">{content}...</p>
                        </div>
                    </div>
                    <Link className="xb-overlay"  to={"/" + "blog" + "/" + `${urlHeading}`}></Link>
                </div>
  
  
  </>
  )
}

export default BlogSmallCard